var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoindt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_indt",
    "data-name": "logo indt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.847,
    height: 18.254,
    viewBox: "0 0 59.847 18.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brand-indt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_273",
    "data-name": "Caminho 273",
    d: "M281.9,31.9h2.944V42.017H281.9Z",
    transform: "translate(-256.472 -27.832)",
    fill: "#005288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_274",
    "data-name": "Caminho 274",
    d: "M291.2,31.9h2.944l2.784,3.961c.7,1.017,1.124,1.82,1.178,1.874h.054c0-.054-.054-.964-.054-1.767V31.9h2.623V42.017h-2.677l-3.1-4.389a14.021,14.021,0,0,1-1.124-1.713h-.054c0,.107.054.749.054,1.552v4.5H291.2Z",
    transform: "translate(-260.795 -27.832)",
    fill: "#005288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_275",
    "data-name": "Caminho 275",
    d: "M312.7,31.9h3.64c3.961,0,5.835,1.981,5.835,4.925s-1.927,5.192-5.942,5.192H312.7V31.9Zm3.747,7.869c1.766,0,2.623-.964,2.623-2.837s-.856-2.73-2.676-2.73h-.749v5.514h.8Z",
    transform: "translate(-270.786 -27.832)",
    fill: "#005288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_276",
    "data-name": "Caminho 276",
    d: "M333.33,34.255H330.6V31.9h8.351v2.355h-2.73v7.762H333.33Z",
    transform: "translate(-279.104 -27.832)",
    fill: "#005288"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_767",
    "data-name": "Grupo 767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_277",
    "data-name": "Caminho 277",
    d: "M253.061,24.3a12.95,12.95,0,0,0-4.229,1.552l2.034,1.124h0a6.535,6.535,0,0,1,2.195-.7c1.767,0,3.319.107,3.319,7.12s-1.552,7.173-3.319,7.173-9.207-4.443-9.207-4.443a3.366,3.366,0,0,1-1.82-2.73,3.344,3.344,0,0,1,1.82-2.677s1.231-.749,2.784-1.606l-1.927-1.071c-.964.589-1.659.964-1.659.964S240,30.67,240,33.347s3.051,4.443,3.051,4.443,7.762,4.711,10.01,4.711,5.3-.054,5.3-9.154C258.361,24.354,255.31,24.3,253.061,24.3Z",
    transform: "translate(-237.002 -24.3)",
    fill: "#005288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_278",
    "data-name": "Caminho 278",
    d: "M239.753,42.6a12.95,12.95,0,0,0,4.229-1.552l-2.034-1.124h0a6.534,6.534,0,0,1-2.195.7c-1.767,0-3.319-.107-3.319-7.12s1.552-7.173,3.319-7.173,9.207,4.443,9.207,4.443a3.366,3.366,0,0,1,1.82,2.73,3.344,3.344,0,0,1-1.82,2.677s-1.231.749-2.837,1.606l1.927,1.071c.964-.589,1.659-.964,1.659-.964s3.051-1.659,3.051-4.336-3.051-4.443-3.051-4.443S241.948,24.4,239.7,24.4s-5.3.054-5.3,9.154C234.454,42.6,237.5,42.6,239.753,42.6Z",
    transform: "translate(-234.4 -24.346)",
    fill: "#005288"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoindt);
export default __webpack_public_path__ + "static/media/logo indt.802a888f9bf25566006a00a0d462089c.svg";
export { ForwardRef as ReactComponent };